import { render, staticRenderFns } from "./WizardRadio.vue?vue&type=template&id=6713c381"
import script from "./WizardRadio.vue?vue&type=script&lang=ts"
export * from "./WizardRadio.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports